import Utils from "../../../../../shared/utils";

export const CLOSE_ICON = Utils.buildNewsletterLink("icons/close.svg");
